export { default as LayoutNextErrorBoundary } from './layout-next-error-boundary';
